import GridContainer from 'components/Grid/GridContainer';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import GridItem from 'components/Grid/GridItem';
import InfoCard from 'components/Info/InfoCard';
import { translate } from 'components/Translation';
import { HeadingMBold, HeadingS, SuccessBold } from 'components/Typography/Typography';
import classNames from 'classnames';
import Call from '@material-ui/icons/Call';
import SMS from '@material-ui/icons/SmsOutlined';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/billingAccounts/detailsStyle';
import { makeStyles } from '@material-ui/core';
import { IBillingAccountInformation } from 'utils/api/models/accounts/billingAccountInformation';
import EBill from 'assets/img/icons/e-bill.svg';
import Button from 'components/CustomButtons/Button';
import Add from '@material-ui/icons/Add';
import CanPerform from 'components/CanPerform/CanPerform';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IEBillsProps {
	isEBill: boolean;
	billingAccountInformation: IBillingAccountInformation | null;
	eBillRecipients: string[];
	editRecipient: (index: number, recipient: string) => void;
	addRecipient: () => void;
}

const EBills = ({ isEBill, billingAccountInformation, eBillRecipients, editRecipient, addRecipient }: IEBillsProps) => {
	const classes = useStyles();
	const eBillHeader = translate(`payments.billingAccounts.ebill${isEBill ? 'Recipients' : ''}`);
	const eBillSubheader = translate(`payments.billingAccounts.ebill.${isEBill ? 'thankyou' : 'beeco'}`);

	return (
		<GridItem xs={12} className={classes.ebillComponentContainer}>
			<div className={classes.eBillHeaderWrapper}>
				<div className={classes.eBillHeader}>
					<img src={EBill} alt="e-bill" className={classes.ebillIcon} />
					<div>
						<div className={classes.ebill}>
							<HeadingMBold color="secondary-light" inline>
								{eBillHeader}
							</HeadingMBold>
						</div>
						<div className={classes.ebillSubheader}>
							<SuccessBold inline>{eBillSubheader}</SuccessBold>
						</div>
					</div>
				</div>
				<div>
					<ConditionalRender
						show={eBillRecipients.length < 2 && isEBill}
						onTrue={() => (
							<CanPerform
								action="active-services:edit-billing-account-add-ebill-recipient"
								yes={
									<Button withIcon color="tertiary-light" onClick={addRecipient}>
										<Add />
										<>{translate('billing.account.add.recipient')}</>
									</Button>
								}
							/>
						)}
					/>
				</div>
			</div>
			<ConditionalRender
				show={isEBill}
				onTrue={() => (
					<GridContainer justify="flex-start">
						<ConditionalRender
							show={!!billingAccountInformation}
							onTrue={() => (
								<GridItem xs={12} sm={6} key={'admin'} className={classes.cardItem}>
									<InfoCard
										elements={[
											{
												title: translate('payments.billingAccounts.recipientEmailAddress'),
												value: billingAccountInformation?.email ?? '',
											},
										]}
									/>
								</GridItem>
							)}
						/>
						<>
							{eBillRecipients.map((recipient, index) => (
								<GridItem xs={12} sm={6} key={index} className={classes.cardItem}>
									<InfoCard
										elements={[
											{
												title: translate('payments.billingAccounts.recipientEmailAddress'),
												value: recipient,
											},
										]}
										buttons={[
											{
												label: translate('edit'),
												onClick: () => editRecipient(index, recipient),
												id: `${recipient}-edit-button`,
											},
										]}
										action="active-services:edit-billing-account-edit-ebill-recipient"
									/>
								</GridItem>
							))}
						</>
					</GridContainer>
				)}
				onFalse={() => (
					<div className={classes.ebillComponent}>
						<HeadingS>{translate('payments.billingAccounts.ebill.toActivate')}</HeadingS>
						<div className={classNames(classes.activateEbillIconComponent, classes.smsIconComponent)}>
							<Call className={classes.activateEbillIcon} />
							<HeadingMBold inline>1235</HeadingMBold>
						</div>
						<HeadingS>{translate('payments.billingAccounts.ebill.orText')}</HeadingS>
						<div className={classes.activateEbillIconComponent}>
							<SMS className={classes.activateEbillIcon} />
							<HeadingMBold inline>{translate('payments.billingAccounts.ebill.text')}</HeadingMBold>
						</div>
					</div>
				)}
			/>
		</GridItem>
	);
};

export default EBills;
